import * as React from 'react';
import * as PropTypes from 'prop-types';

import {IconAdd32, Tile} from 'pac-ux-components';

import {I18n} from '@aws-amplify/core';

import {Box, Center, Grid} from '@mantine/core';

export const AddAccountProfile = ({ accountsCount, onClick }) => {
    return (
        <Tile onClick={onClick}>
            <Grid gutter="sm" p="xs" className="cursor-pointer">
                <Grid.Col span={3}>
                    <Center p="sm">
                        <IconAdd32 />
                    </Center>
                </Grid.Col>

                <Grid.Col span={9}>
                    <Box mt="lg">
                        {accountsCount > 0
                            ? I18n.get('Use another account')
                            : I18n.get('Add an account')}
                    </Box>
                </Grid.Col>
            </Grid>
        </Tile>
    );
};

AddAccountProfile.propTypes = {
    accountsCount: PropTypes.number,
    onClick: PropTypes.func.isRequired,
};

AddAccountProfile.defaultProps = {
    accountsCount: 0,
};
